export default __webpack_public_path__ + "static/media/onder-ortel-vNahmM7Bmqw-unsplash.8fd86368.jpg";